import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'lib-difusion-dialog',
    templateUrl: './difusion-dialog.component.html',
    styleUrls: ['./difusion-dialog.component.css']
})
export class DifusionDialogComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<DifusionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
    }

    difundir(valor: string): void {
        this.dialogRef.close(valor);
    }

    ngOnInit(): void {
    }

}
